export const stallApplicationQueryKeys = {
  all: () => "stall-application"
};
